import { useState } from 'react';
import { useForm, UseFormMethods } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { apiFetch } from 'services/apiFetch';
import yup from 'utils/yup';

type UseFormType = Partial<Pick<UseFormMethods, 'register' | 'errors'>> & {
  onSubmit: () => void,
  loading: boolean,
};

type Props = {
  setShowSuccessDialog: React.Dispatch<React.SetStateAction<boolean>>,
};

const schema = yup.object().shape({
  email: yup.string().email().required().label('E-mail'),
});

export default ({ setShowSuccessDialog }:Props):UseFormType => {
  const [loading, setLoading] = useState(false);

  const {
    register, handleSubmit, errors, setError,
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  const recoverFail = () => setError('email', {
    type: 'check-recover',
    message: 'Não foi possível solicitar a troca de senha. E-mail não reconhecido.',
  });

  const onSubmit = handleSubmit(async (formData) => {
    setLoading(true);

    try {
      const response = await apiFetch('/password', {
        method: 'POST',
        body: JSON.stringify({ email: formData.email }),
      });

      if (response.ok) {
        setShowSuccessDialog(true);
      } else {
        recoverFail();
      }
    } catch {
      recoverFail();
    }

    setLoading(false);
  });

  return {
    register,
    onSubmit,
    errors,
    loading,
  };
};
